import { createContext, type ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import type { AuthQuelle, NutzerInfo } from './auth-source.js';

interface AuthWert {
  laedt: boolean;
  nutzer: NutzerInfo | null;
  meldeAb: () => Promise<void>;
}

const AuthKontext = createContext<AuthWert | null>(null);

export function AuthProvider({ quelle, children }: { quelle: AuthQuelle; children: ReactNode }) {
  const [laedt, setLaedt] = useState(true);
  const [nutzer, setNutzer] = useState<NutzerInfo | null>(null);

  useEffect(() => {
    return quelle.beobachte((naechster) => {
      setNutzer(naechster);
      setLaedt(false);
    });
  }, [quelle]);

  const wert = useMemo<AuthWert>(
    () => ({ laedt, nutzer, meldeAb: () => quelle.meldeAb() }),
    [laedt, nutzer, quelle],
  );

  return <AuthKontext.Provider value={wert}>{children}</AuthKontext.Provider>;
}

export function useAuth(): AuthWert {
  const wert = useContext(AuthKontext);
  if (!wert) {
    throw new Error('useAuth braucht einen AuthProvider oberhalb im Baum.');
  }
  return wert;
}

/**
 * Der angemeldete Nutzer, ohne Pflicht zum Provider. Fuer Seiten, die ihn nur fuer die ANZEIGE
 * brauchen (fremder Auftrag in der Gesamtansicht: Entscheiden ausblenden). Im Betrieb steht jede
 * dieser Seiten unter dem Guard und damit unter dem Provider; fehlt er, verhaelt sich die Seite
 * wie fuer den Besitzer. Das ist unschaedlich, weil Backend und Rules fremde Schreibzugriffe
 * ohnehin abweisen -- `useAuth` dagegen bleibt streng, wo der Nutzer Daten bestimmt.
 */
export function useAngemeldeterNutzer(): NutzerInfo | null {
  return useContext(AuthKontext)?.nutzer ?? null;
}
